module.exports = new __parcel__URL__("6611.637658b1.jpg").toString();